module.exports = __webpack_public_path__ + "media/Video 105.b8b9dde2.mp4";